import "../../scss/style.scss";
import { init } from "./bootstrap";
import { stageInit } from "./stage";
import { sliderInit } from "./slider";
import { initHeaderFunctions } from "./header";
import { initCookie } from "./cookie";

document.addEventListener("DOMContentLoaded", () => {
  init();
  initCookie();
  stageInit();
  sliderInit();
  initHeaderFunctions();
});
